import React from "react";
import { /*Modal,*/ Table } from "antd";
import Column from "antd/lib/table/Column";
import { Header } from "../../components/Header";
import { Loading } from "../../components/Loading";
import { addTomanPriceComma } from "../../core/utils";
import BuyProductReportFilter from "./BuyProductReportFilter/BuyProductReportFilter";
import styles from "./BuyProductReport.module.css";
import { ContentCard } from "../../components/ContentCard/ContentCard";
import useBuyProductReport from "../../hooks/useBuyProductReport";
import PlateNumberComponent from "../../components/PlateNumberComponent";

export const BuyProductReport = () => {
  const {
    loading,
    buyProductReport,
    getBuyProductReport,
    provinces,
    users,
    cities,
    categories,
    setCities,
    form,
    setSearch,
    changePage,
    getUsers,
    exportBuyProductReport,
  } = useBuyProductReport();
  // const [serviceCenterModalOpen, setServiceCenterModalOpen] = useState(false);
  return (
    <>
      <Header
        title="Purchases Report"
        activeItem="BuyProductReport"
        leftTitle={`Total Purchases: ${buyProductReport?.length || 0}`}
      />

      <ContentCard
        filter={
          <BuyProductReportFilter
            getBuyProductReport={getBuyProductReport}
            users={users}
            provinces={provinces}
            cities={cities}
            exportBuyProductReport={exportBuyProductReport}
            setCities={setCities}
            categories={categories}
            form={form}
            setSearch={setSearch}
            getUsers={getUsers}
          />
        }
      >
        <Loading isLoading={loading}>
          <Table
            tableLayout="auto"
            size="middle"
            className={styles.BuyProductReport}
            scroll={{ x: 1300 }}
            dataSource={buyProductReport || []}
            pagination={{
              position: ["bottomCenter"],
              current: 1,
              pageSize: 10,
              total: 5,
              onChange: changePage,
            }}
          >
            <Column
              title={"#"}
              dataIndex="index"
              key="index"
              render={(_value, _item, index) => <>{index + 1}</>}
            />
            <Column
              title="City"
              dataIndex="address"
              key="address"
              render={(address) => (
                <>
                  <small className="color-promotion-s1 mr-10 ml-5">
                    [{address.province}]
                  </small>
                  <span className="mx-10">{address.city}</span>
                </>
              )}
            />
            <Column
              title="Supervisor Name"
              dataIndex="operator"
              key="operator"
              render={(operator) => <span>{operator.operator_name}</span>}
            />
            <Column
              title="Car"
              dataIndex="user_car"
              key="user_car"
              render={(user_car) => <>{user_car?.car_name || "-"}</>}
            />
            <Column
              title="Plate Number"
              dataIndex="user_car"
              key="user_car"
              render={(user_car) => user_car?.plate_number || ""}
            />
            <Column
              title="Driver Phone Number"
              dataIndex="user"
              key="user"
              render={(user) => <>{user.driver_phone_number}</>}
            />
            <Column
              title="Driver Name"
              dataIndex="user"
              key="user"
              render={(user) => (
                <>
                  {user?.first_name} {user?.last_name}
                </>
              )}
            />
            <Column
              title="Center Name"
              dataIndex="service_center"
              key="service_center"
              render={(service_center) => service_center?.name}
              // render={(service_center) => {
              //   return (<>
              //     <span>{service_center?.name}</span>
              //     <Modal
              //       className="user-modal"
              //       visible={serviceCenterModalOpen}
              //       footer={null}
              //       centered={true}
              //       closable={false}
              //       destroyOnClose={true}><div className="flex-row flex-row  flex-items-center"><div>شماره تماس مرکز: {service_center.phone}</div><div>آدرس مرکز: {service_center.address}</div></div></Modal>
              //   </>)
              // }}
            />
            <Column
              title="Order Number"
              dataIndex="id"
              key="id"
              render={(id) => <>{id}</>}
            />
            <Column
              title="Product Category"
              dataIndex="product"
              key="product"
              render={(product) => <>{product.category}</>}
            />
            <Column
              title="Product"
              dataIndex="product"
              key="product"
              render={(product) => <>{product.name}</>}
            />
            <Column
              title="Quantity"
              dataIndex="quantity"
              key="quantity"
              render={(quantity) => (
                <span className="text-center">{quantity}</span>
              )}
            />
            <Column
              title="Total Price"
              dataIndex="payable_amount"
              key="payable_amount"
              render={(payable_amount) => (
                <>{addTomanPriceComma(payable_amount)} USD</>
              )}
            />
            <Column
              title="Purchase Date"
              dataIndex="purchase_date"
              key="purchase_date"
              render={(purchase_date) => <>{purchase_date.purchase_date}</>}
            />
            <Column
              title="Next Purchase Date"
              dataIndex="purchase_date"
              key="purchase_date"
              render={(purchase_date) => (
                <>{purchase_date.next_purchase_date}</>
              )}
            />
            <Column
              title="Delivery Date"
              dataIndex="delivery_date"
              key="delivery_date"
              render={(delivery_date) => delivery_date || "-"}
            />
            <Column
              title="Delay in Purchase"
              dataIndex="purchase_date"
              key="purchase_date"
              render={(purchase_date) => <>{purchase_date.delay_in_purchase}</>}
            />
          </Table>
        </Loading>
      </ContentCard>
    </>
  );
};
